var map = {
	"./BALL0001.jpg": "4599",
	"./BALL0002.jpg": "ac7a",
	"./BALL0003.jpg": "7806",
	"./BALL0004.jpg": "1824",
	"./BALL0005.jpg": "57be",
	"./BALL0006.jpg": "3d65",
	"./BALL0007.jpg": "eab2",
	"./BALL0008.jpg": "5d63",
	"./BALL0009.jpg": "ef68"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4134";